import React, { useMemo, useState } from 'react';
import MapComponent from './MapComponent';
import ListComponent from './ListComponent';
import { useWorkshops } from '../WorkshopContext';

const MapSection = () => {
  const { state } = useWorkshops();

  const [selected, setSelected] = useState('All'); // 'All' | 'Urban' | 'Agriculture' | 'Forest'

  const counts = useMemo(() => {
    const tally = { Urban: 0, Agriculture: 0, Forest: 0 };
    state.workshops.forEach(w => {
      const lus = Array.isArray(w.land_uses) ? w.land_uses : [];
      if (lus.includes('Urban')) tally.Urban += 1;
      if (lus.includes('Agriculture')) tally.Agriculture += 1;
      if (lus.includes('Forest')) tally.Forest += 1;
    });
    return tally;
  }, [state.workshops]);
  const totalCount = state.workshops.length;

  const filteredWorkshops = useMemo(() => {
    if (selected === 'All') return undefined; // children will fall back to full list
    return state.workshops.filter(w => Array.isArray(w.land_uses) && w.land_uses.includes(selected));
  }, [state.workshops, selected]);
  return (    
    <section id="workshops" className="section">
      <div className="container">
        <div className="columns">
          <div className="column is-8">
            <div className="level mb-5">
              <div className="level-left">
                <h3 className="title mb-0">Workshops overview</h3>
              </div>
              <div className="level-right">
                <div className="tags has-text-weight-normal">
                  
                  <span
                    className={`tag ${selected === 'Agriculture' ? 'is-dark' : 'is-light'}`}
                    onClick={() => setSelected('Agriculture')}
                    style={{ cursor: 'pointer' }}
                  >
                    Agriculture ({counts.Agriculture})
                  </span>
                  <span
                    className={`tag ${selected === 'Forest' ? 'is-dark' : 'is-light'}`}
                    onClick={() => setSelected('Forest')}
                    style={{ cursor: 'pointer' }}
                  >
                    Forest ({counts.Forest})
                  </span>
                  <span
                    className={`tag ${selected === 'Urban' ? 'is-dark' : 'is-light'}`}
                    onClick={() => setSelected('Urban')}
                    style={{ cursor: 'pointer' }}
                  >
                    Urban ({counts.Urban})
                  </span>
                  <span
                    className={`tag ${selected === 'All' ? 'is-dark' : 'is-light'}`}
                    onClick={() => setSelected('All')}
                    style={{ cursor: 'pointer' }}
                  >
                    All ({totalCount})
                  </span>
                </div>
              </div>
            </div>
            <p>22 workshops were conducted and analyzed gathering insights from more than 500 stakeholders across different groups: public and private actors, knowledge and education, land steward, and citizen and from different perspectives: economic, environmental, political, societal, technological ...</p>
          </div>
          <div className="column">
            <h3 className="title">Locations</h3>
            <p>Click on a workshop from the list to view its details below or check up to 5 workshops to compare them side by side.</p>            
          </div>
        </div>
      </div>
      <div className="container">
        <div className="columns">
          <div className="column is-8">
            <MapComponent workshops={filteredWorkshops} />
          </div>
          <div className="column">
            <ListComponent workshops={filteredWorkshops} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
